import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class LongEquityInvestment extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '长期股权投资';
    }

    getColumns = () => {
        return [{
            title: '期初余额',
            dataIndex: 'initialBalance'
        }, {
            title: '期末余额',
            dataIndex: 'finalBalance'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/LongEquityInvestment.jsx